import React, { ChangeEvent, useState } from 'react';
import {
  AspectRatio,
  Box,
  Center,
  Grid,
  GridItem,
  Heading,
  Select
} from '@chakra-ui/react';
import { LayoutContainer } from '@components';
import Image from 'next/legacy/image';
import { TopCard, BlogHeader, BlogPostCard } from '@components';

export interface Post {
  featured?: boolean;
  slug: string;
  date: string;
  title: string;
  category?: string;
  excerpt?: string;
  coverImage?: { asset: string };
  author: {
    name: string;
    picture: string;
  };
}

interface ListingProps {
  allBlogs: Post[];
  categories: string[];
}

const ALL_CATEGORIES = 'all-categories';

export function Listing({ allBlogs, categories }: ListingProps): JSX.Element {
  const [currentCategory, setCurrentCategory] =
    useState<string>(ALL_CATEGORIES);

  const handleCategoryFilter = (e: ChangeEvent<HTMLSelectElement>): void => {
    setCurrentCategory(e.target.value);
  };

  const featuredPost = allBlogs.find(blog => blog.featured === true);

  return (
    <>
      <LayoutContainer pos="relative" bg="background" verticalPadding="md">
        <AspectRatio
          ratio={1400 / 1190}
          w={'1196px'}
          h="962px"
          pos="absolute"
          right="200px"
          top="-100px"
          pointerEvents="none"
          draggable={false}
          userSelect="none"
        >
          <Image src="/images/grid-pattern.svg" alt="" layout="fill" />
        </AspectRatio>

        <BlogHeader />
        <Box>
          <TopCard post={featuredPost ? featuredPost : allBlogs[0]} />
        </Box>
      </LayoutContainer>

      <LayoutContainer bg="#F8F9FC" verticalPadding={'sm'}>
        <Box mb={10} mt={{ base: 4, md: 0 }}>
          <Heading size="sm" mb={1} color="primary.500">
            Filter
          </Heading>
          <Select
            value={currentCategory}
            onChange={handleCategoryFilter}
            w="150px"
          >
            <option value={ALL_CATEGORIES}>All categories</option>
            {categories.map(category => (
              <option key={category} value={category}>
                {category}
              </option>
            ))}
          </Select>
        </Box>

        <Center>
          <Grid
            templateColumns={{
              base: 'repeat(1, 1fr)',
              lg: 'repeat(3, 1fr)'
            }}
            gap="24px"
          >
            {allBlogs
              .filter(post =>
                currentCategory === ALL_CATEGORIES
                  ? true
                  : currentCategory === post.category
              )
              .map(post => (
                <GridItem key={post.slug} zIndex={10}>
                  <BlogPostCard post={post} />
                </GridItem>
              ))}
          </Grid>
        </Center>
      </LayoutContainer>
    </>
  );
}
